import { render } from "./Inventory.vue?vue&type=template&id=6a9d0aee&scoped=true"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"

import "./Inventory.vue?vue&type=style&index=0&id=6a9d0aee&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/MISTOCK/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9d0aee"]])

export default __exports__